(function () {
  'use strict';
  function money(c) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') { s = s.slice(0, -3); }
    return s + ' €';
  }

  document.querySelectorAll('[data-rv-product]').forEach(function (root) {
    var data = root.querySelector('[data-rv-variants]');
    if (!data) { return; }
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-rv-variant-id]');
    var sets = root.querySelectorAll('[data-rv-option]');
    var main = root.querySelector('[data-rv-main]');
    var thumbs = root.querySelectorAll('[data-rv-thumb]');
    var slides = root.querySelectorAll('[data-rv-slide]');
    var track = root.querySelector('[data-rv-slides]');
    var colour = null;

    function setMain(src) {
      var img = main && main.querySelector('img');
      if (img && src) { img.src = src; img.removeAttribute('srcset'); }
    }

    function filterThumbs() {
      if (!colour) { return; }
      thumbs.forEach(function (t) {
        var c = t.getAttribute('data-color') || '';
        t.hidden = !(c === '' || c === colour);
        t.setAttribute('aria-current', 'false');
      });
      slides.forEach(function (s) {
        var c = s.getAttribute('data-color') || '';
        s.hidden = !(c === '' || c === colour);
      });
      if (track) { track.scrollLeft = 0; }
    }

    function chosen() {
      var a = [];
      sets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        a.push(c ? c.value : null);
        var l = fs.querySelector('[data-rv-option-label]');
        if (l && c) { l.textContent = c.value; }
        if (c && c.hasAttribute('data-hex')) {
          colour = c.value;
          if (main) {
            main.style.setProperty('--rv-c', c.getAttribute('data-hex'));
            var n = main.querySelector('[data-rv-colour-name]');
            if (n) { n.textContent = c.value; }
          }
        }
      });
      return a;
    }

    function update(push) {
      var prev = colour;
      var a = chosen();
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === a[i]; });
      })[0];
      document.querySelectorAll('[data-rv-add]').forEach(function (b) {
        var withPrice = b.hasAttribute('data-rv-with-price');
        if (!v) { b.disabled = true; b.textContent = 'Indisponible'; return; }
        b.disabled = !v.available;
        b.textContent = v.available ? ('Ajouter au panier' + (withPrice ? ' · ' + money(v.price) : '')) : 'Épuisé';
      });
      if (colour !== prev) { filterThumbs(); }
      if (!v) { return; }
      idInput.value = v.id;
      document.querySelectorAll('[data-rv-price]').forEach(function (p) { p.textContent = money(v.price); });
      document.querySelectorAll('[data-rv-sticky-label]').forEach(function (p) { p.textContent = money(v.price) + ' · ' + v.options.join(' · '); });
      if (colour !== prev && v.featured_image && v.featured_image.src) { setMain(v.featured_image.src); }
      if (push) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-rv-option]')) { update(true); }
    });
    update(false);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMain(t.getAttribute('data-src'));
        thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  });

  var drawer = document.querySelector('[data-rv-drawer]');
  if (drawer) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lines = drawer.querySelector('[data-rv-lines]');
    var empty = drawer.querySelector('[data-rv-empty]');
    var foot = drawer.querySelector('[data-rv-foot]');
    var total = drawer.querySelector('[data-rv-total]');
    var msg = drawer.querySelector('[data-rv-msg]');
    var tpl = drawer.querySelector('[data-rv-line-tpl]');
    var closeBtn = drawer.querySelector('.cd__x');
    var lastFocus = null;
    var closeTimer = null;

    var render = function (cart) {
      document.querySelectorAll('[data-rv-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = !cart.item_count;
      });
      lines.textContent = '';
      cart.items.forEach(function (it) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        li.setAttribute('data-key', it.key);
        li.setAttribute('data-qty', it.quantity);
        var im = li.querySelector('.cd__img');
        if (it.image) { im.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240'; } else { im.hidden = true; }
        li.querySelector('.cd__t').textContent = it.product_title;
        li.querySelector('.cd__v').textContent = (it.variant_title || '').split(' / ').join(' · ');
        li.querySelector('.cd__n').textContent = it.quantity;
        li.querySelector('.cd__p').textContent = money(it.final_line_price);
        lines.appendChild(li);
      });
      empty.hidden = cart.item_count > 0;
      foot.hidden = cart.item_count === 0;
      total.textContent = money(cart.total_price);
    };
    var getCart = function () {
      return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    };
    var say = function (t) { msg.textContent = t || ''; msg.hidden = !t; };
    var openDrawer = function () {
      clearTimeout(closeTimer);
      if (drawer.hidden) { lastFocus = document.activeElement; }
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      closeBtn.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 270);
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-rv-cart-open]')) {
        e.preventDefault();
        say('');
        getCart().then(openDrawer, function () { window.location.href = base + 'cart'; });
        return;
      }
      if (e.target.closest('[data-rv-close]')) { closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { closeDrawer(); }
    });

    lines.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (!b) { return; }
      var li = b.closest('[data-key]');
      var d = parseInt(b.getAttribute('data-q'), 10);
      var q = d === 0 ? 0 : Math.max(0, parseInt(li.getAttribute('data-qty'), 10) + d);
      lines.setAttribute('aria-busy', 'true');
      fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: li.getAttribute('data-key'), quantity: q })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { say('La mise à jour du panier a échoué. Réessayez.'); })
        .then(function () { lines.removeAttribute('aria-busy'); });
    });

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) { return; }
      e.preventDefault();
      var btns = document.querySelectorAll('[data-rv-add]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      say('');
      var id = Number(new FormData(f).get('id'));
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); })
        .then(getCart)
        .catch(function (err) {
          say((err && err.description) || 'Impossible d’ajouter ce pyjama pour le moment. Réessayez.');
          return getCart();
        })
        .then(openDrawer)
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }, true);
  }
})();
